module.exports = __webpack_public_path__ + "static/media/snappy.cdba9e39.svg";